import { mapState as rootMapState } from 'pinia';
import { usePageStore, useUserStore } from "@/store";

import { mapState } from '@/store/helpers';
import { currencyFormat } from '../../common/format';
import signLog from '@/components/sign-log';
import { normal } from '../defaultSpacing';
export default {
    i18next: {
        ns: 'md-sold-estimate'
    },
    data: function() {
        const config = this.$parent?.config || { fullColumn: false, ...normal };
        return {
            ...config,
            title: '',
            requestButtonText: '',
            desc: '',
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            currencySymbol: store => store.currency?.symbol,
        }),
        ...rootMapState(useUserStore, {
            user: store => store.user,
        }),
        ...mapState({
            info: store => store.info,
            estPrice: store => store.estPrice,
            diffPrice: store => store.diffPrice,
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        //  Formatted Valuation 
        estPriceValue() {
            return this.estPrice
                ? currencyFormat(this.estPrice, false, 0, this.currencySymbol)
                : '?';
        },
        //  formatted difference 
        diffPriceValue() {
            let price = this.diffPrice;
            return price > 0
                ? '+' + currencyFormat(price, true, 0, this.currencySymbol)
                : '-' + currencyFormat(-price, true, 0, this.currencySymbol);
        },
        cmpTitle() {
            return this.$t('md-sold-estimate.thinkingAboutSelling');
        },
        cmpRequestButtonText() {
            return this.$t('md-sold-estimate.requestConsultation');
        },
        cmpDesc() {
            return this.$t('md-sold-estimate.contactUsForMoreInformation');
        },
        diffValueDesc() {
            let { soldDate } = this.info;
            //  get year 
            if (soldDate) {
                let year = new Date(soldDate).getFullYear();
                return this.$t('md-sold-estimate.sinceLastSoldIn', { year });
            }
        }
    },
    watch: {
        '$parent.config'(a) {
            if (a) {
                for (let i in a) {
                    this[i] = a[i];
                }
            }
        }
    },
    methods: {
        openRegisterPop() {
            signLog.register(
                {
                    registerTitle: null,
                    submitRegister: null
                },
                'evaluationRegister'
            );
        }
    }
};
